import type { ValuesOf } from '@shared/types';

export const SnackType = {
  Info: 'info',
  Error: 'error',
  Success: 'success',
  Warn: 'warn',
} as const;

export type SnackType = ValuesOf<typeof SnackType>;

export interface Snack {
  id: number;
  message: string;
  type: SnackType;
}
